"use client";
import React, { useEffect, useState } from "react";
import dynamic from "next/dynamic";

import "../../marken/marken.css";

import { TopSectionMarken } from "../../marken/sections/TopSection";
import { AutoVerkaufenGrid } from "@/common/AutoVerkaufenGrid";
import { Banner } from "@/common/Banner";
import sellCarCash from "@/assets/auto-verkaufen/Rückbank-autoverkauf.avif";

import höchstenPreis from "@/assets/auto-verkaufen/Frau-verkauft-ihr-auto.webp";
import BannerImage2 from "@/assets/auto-verkaufen/AutoeinfachlosBannerBig2.avif";
import BannerImage3 from "@/assets/auto-verkaufen/AutoeinfachlosBannerBig3.avif";
import BildTextInfo from "@/components/BildTextInfo/BildTextInfo";

// Ratgeber SERVERSEITIG rendern (dynamic OHNE die SSR-Abschaltung, Playbook 2.6):
// die sechs "Mehr zum Thema"-Kacheln verlinken u. a. /auto-verkaufen.
const Ratgeber = dynamic(() =>
  import("@/components/Ratgeber/Ratgeber").then((m) => m.default)
);

// Only needed when the user reaches step 12; avoid loading auth-related JS/CSS on initial paint.
const AnmeldenSection = dynamic(() => import("@/app/anmelden/AnmeldenStepRedirect"), {
  ssr: false,
});

function AbwrackpraemieVerschrottung() {
  const [step, setStep] = useState(1);
  // selected values
  const [selectedBrand, setSelectedBrand] = useState({ id: "", name: "" });
  const [selectedModel, setSelectedModel] = useState({ id: "", name: "" });
  const [selectedYear, setSelectedYear] = useState({ id: "", name: "" });
  const [selectedBauform, setSelectedBauform] = useState({ id: "", name: "" });
  const [selectedFuel, setSelectedFuel] = useState({ id: "", name: "" });
  const [selectedVariant, setSelectedVariant] = useState({ id: "", name: "" });
  const [selectedPs, setSelectedPs] = useState({ id: "", name: "" });
  const [selectedTransmission, setSelectedTransmission] = useState({
    id: "",
    name: "",
  });
  const [selectedDoors, setSelectedDoors] = useState({ id: "", name: "" });
  const [selectedModelType, setSelectedModelType] = useState({
    id: "",
    name: "",
  });
  const [selectedKmStand, setSelectedKmStand] = useState("");
  const isSecondaryMethod = true;

  useEffect(() => {
    if (step >= 10) {
      if (typeof AnmeldenSection?.preload === "function") {
        AnmeldenSection.preload();
      } else {
        import("@/app/anmelden/AnmeldenStepRedirect");
      }
    }
  }, [step]);


  return (
    <div className="home-container">
      <TopSectionMarken
        title="Abwrackprämie & Auto verschrotten – alle Fakten"
        link="/guides/abwrackpraemie-verschrottung"
        linkname="Abwrackprämie & Auto verschrotten"
        text={
          <>
            84% der Autoeinfachlos-Kunden bekommen mehr Geld.*{" "}
            <br className="desktop" />
            Hol dir deine kostenlose und sofortige Bewertung.
          </>
        }
        removePadding={true}
        step={step}
        setStep={setStep}
        selectedBrand={selectedBrand}
        setSelectedBrand={setSelectedBrand}
        selectedModel={selectedModel}
        setSelectedModel={setSelectedModel}
        selectedYear={selectedYear}
        setSelectedYear={setSelectedYear}
        selectedBauform={selectedBauform}
        setSelectedBauform={setSelectedBauform}
        selectedFuel={selectedFuel}
        setSelectedFuel={setSelectedFuel}
        selectedVariant={selectedVariant}
        setSelectedVariant={setSelectedVariant}
        selectedPs={selectedPs}
        setSelectedPs={setSelectedPs}
        selectedTransmission={selectedTransmission}
        setSelectedTransmission={setSelectedTransmission}
        selectedDoors={selectedDoors}
        setSelectedDoors={setSelectedDoors}
        setSelectedModelType={setSelectedModelType}
        selectedModelType={selectedModelType}
        selectedKmStand={selectedKmStand}
        setSelectedKmStand={setSelectedKmStand}
      />

      {step === 12 && (
        <>
          <AnmeldenSection
            title="Bitte gib deine E-Mail-Adresse ein, um fortzufahren"
            fin={null}
            isManual={isSecondaryMethod}
            marke={selectedBrand}
            model={selectedModel}
            baujahr={selectedYear}
            bodytype={selectedBauform}
            fueltype={selectedFuel}
            variant={selectedVariant}
            ps={selectedPs}
            gearbox={selectedTransmission}
            doors={selectedDoors}
            modelType={selectedModelType}
            kmStand={selectedKmStand}
            page="/auto-verkaufen"
          />
          <Banner removeContent className="Banner-anmelden" />
        </>
      )}

      {step !== 12 && (
        <div className="Page background-color">
          <div className="Page-wrapper">
            <AutoVerkaufenGrid
              image={sellCarCash}
              leftTitle="Was ist die Verschrottungsprämie?"
              leftText={
                <>
                  <p>
                    Immer wieder ist in den Medien von Abwrackprämien die Rede,
                    die Autobesitzer dazu bewegen sollen, alte Fahrzeuge gegen
                    umweltfreundlichere Neuwagen einzutauschen. Doch was verbirgt
                    sich dahinter? Gibt es in Österreich eine staatliche
                    Abwrackprämie? Welche Herstellerprogramme existieren? Und
                    wann lohnt sich der Weg zur Verschrottung statt eines
                    Verkaufs? Dieser Ratgeber informiert dich über die aktuelle
                    Lage, zeigt Vorteile und Nachteile auf und bietet
                    Alternativen.
                  </p>
                </>
              }
              rightFirstTitle="Geschichte der Abwrackprämie"
              rightFirstText={
                <>
                  <p>
                    Die Abwrackprämie (offiziell „Umweltprämie“) wurde 2009 in
                    Deutschland eingeführt, um die Wirtschaft anzukurbeln und
                    alte Fahrzeuge mit hoher Schadstoffbelastung von der Straße
                    zu holen. Wer ein altes Auto (mindestens neun Jahre alt)
                    verschrotten ließ und einen Neuwagen kaufte, erhielt 2 500
                    Euro. Das Programm war zeitlich begrenzt, wurde intensiv
                    beworben und führte zu einem sprunghaften Anstieg der
                    Neuwagenverkäufe. In Österreich gab es ähnliche, aber
                    deutlich kleinere Programme auf regionaler Ebene.
                  </p>

                  <h3>Derzeitige Situation in Österreich</h3>
                  <p>
                    Aktuell existiert keine nationale Abwrackprämie für
                    Privatkunden. Dennoch haben einige Hersteller Eigeninitiativen
                    gestartet:
                  </p>

                  <ul className="custom-unordered-list">
                    <li>
                      <strong>Volkswagen (VW):</strong> Bei Verschrottung eines
                      alten Diesels gibt es bis zu 3 000 Euro Rabatt auf
                      ausgewählte Modelle. Wer ein Erdgasfahrzeug wählt, erhält
                      4 000 Euro Rabatt.
                    </li>
                    <li>
                      <strong>Audi:</strong> Bis zu 10 000 Euro für
                      Plug‑in‑Hybridmodelle wie den Q7 e‑tron. Die Prämie variiert
                      je nach Modell.
                    </li>
                    <li>
                      <strong>Skoda:</strong> 1 000–3 500 Euro Rabatt bei
                      Verschrottung eines alten Diesels; mehr für Erdgasmodelle.
                    </li>
                    <li>
                      <strong>Weitere Marken:</strong> Auch Hyundai, Toyota oder
                      Renault bieten zeitweise Sonderaktionen an, wenn alte Autos
                      verschrottet werden.
                    </li>
                  </ul>

                  <p>
                    Diese Herstellerprämien gelten nur beim Kauf eines Neuwagens
                    und sind oft regional begrenzt. Sie können mit staatlichen
                    E‑Mobilitätsförderungen kombiniert werden, wenn man einen
                    Elektro- oder Hybridwagen kauft.
                  </p>
                </>
              }
              rightSecondTitle="Vorteile der Abwrackprämie"
              rightSecondText={
                <>
                  <ul className="custom-unordered-list secondary">
                    <li>
                      <strong>Umweltschutz:</strong> Alte, schadstoffintensive
                      Fahrzeuge werden aus dem Verkehr gezogen; moderne Autos
                      erfüllen höhere Abgasnormen.
                    </li>
                    <li>
                      <strong>Finanzieller Anreiz:</strong> Die Prämie senkt den
                      Kaufpreis des Neuwagens.
                    </li>
                    <li>
                      <strong>Reiz für Neuwagenkäufer:</strong> Wer ohnehin über
                      einen Neuwagen nachdenkt, profitiert von der zusätzlichen
                      Reduktion.
                    </li>
                  </ul>
                </>
              }
            />

            <div className="Banner-sections">
              <BildTextInfo
                image={BannerImage2}
                revert
                h2
                isBig
                fontSize="36px"
                title="Nachteile und Kritik"
                alt="Nachteile und Kritik zur Abwrackprämie"
                text={
                  <>
                    <ul className="custom-unordered-list">
                      <li>
                        <strong>Verlagerung statt Reduktion:</strong> Das alte
                        Auto wird zwar verschrottet, aber die Produktion eines
                        neuen Fahrzeugs verursacht ebenfalls CO₂. Die
                        Umweltbilanz ist nicht zwangsläufig positiv.
                      </li>
                      <li>
                        <strong>Ausschlusskriterien:</strong> In der Regel wird
                        nur beim Kauf eines Neuwagens eine Prämie gewährt. Wer
                        keinen Neuwagen kaufen will, geht leer aus.
                      </li>
                      <li>
                        <strong>Marktverzerrung:</strong> Kurzfristig werden
                        viele Neuwagen verkauft, doch der Effekt ist zeitlich
                        begrenzt.
                      </li>
                      <li>
                        <strong>Wertverlust:</strong> Der Neuwagen verliert trotz
                        Prämie nach der Zulassung sofort an Wert; die Prämie gleicht
                        das nicht immer aus.
                      </li>
                    </ul>
                  </>
                }
              />

              <BildTextInfo
                image={BannerImage3}
                h2
                isBig
                fontSize="36px"
                title="Auto verschrotten – Ablauf und Kosten"
                alt="Auto verschrotten - Ablauf und Kosten"
                text={
                  <>
                    <p>
                      Wenn du dein Auto verschrotten willst, musst du es zu einem
                      zertifizierten Verwertungsbetrieb bringen. So gehst du vor:
                    </p>
                    <ul className="custom-unordered-list">
                      <li>
                        <strong>Entsorgungshof finden:</strong> Nur anerkannte
                        Betriebe dürfen Autozerlegung durchführen. In Österreich
                        gibt es Netzwerke wie die Car-Recycling-Organisation.
                      </li>
                      <li>
                        <strong>Fahrzeug abgeben:</strong> Der Betrieb nimmt das
                        Auto entgegen, entnimmt Flüssigkeiten, demontiert Teile
                        und bereitet es für die Schredderanlage vor.
                      </li>
                      <li>
                        <strong>Verwertungsnachweis erhalten:</strong> Damit
                        kannst du nachweisen, dass das Auto fachgerecht entsorgt
                        wurde. Der Nachweis ist wichtig, um die Abmeldung zu
                        beantragen und die Kfz-Steuer zu stoppen.
                      </li>
                      <li>
                        <strong>Abmeldung:</strong> Mit dem Verwertungsnachweis
                        meldest du das Auto bei der Zulassungsstelle ab. Viele
                        Verwertungsbetriebe bieten diesen Service direkt an.
                      </li>
                      <li>
                        <strong>Kosten:</strong> Das Verschrotten ist für den
                        Fahrzeughalter kostenlos, wenn alle wesentlichen
                        Komponenten vorhanden sind. Sind Teile (z. B. Motor,
                        Katalysator) entfernt, können Gebühren anfallen.
                      </li>
                    </ul>

                    <h3>Verkauf statt Verschrottung?</h3>
                    <p>
                      Selbst alte und defekte Autos erzielen oft noch einen Wert,
                      da Ersatzteile und Altmetall gefragt sind. Autoeinfachlos
                      vermittelt dein Auto an über 5 000 Händler in Österreich –
                      auch wenn es nicht mehr fahrtauglich ist. Der Verkauf lohnt
                      sich in vielen Fällen mehr als die Verschrottung, da du
                      sofort Geld bekommst und dich nicht an einen Neuwagenkauf
                      binden musst. Prüfe daher vor dem Verschrotten, ob du nicht
                      einen höheren Erlös erzielen kannst.
                    </p>

                    <h2>Umweltfreundliche Alternativen</h2>
                    <ul className="custom-unordered-list">
                      <li>
                        <strong>E-Auto-Förderungen:</strong> Der Bund und manche
                        Länder fördern Elektromobilität mit Zuschüssen (bis zu
                        5 000 Euro) und steuerlichen Vergünstigungen.
                      </li>
                      <li>
                        <strong>Nachrüstung:</strong> Für bestimmte Dieselmodelle
                        gibt es Hardware-Nachrüstungen, um die Abgasnorm zu
                        verbessern. Dadurch kann das Auto weiter genutzt werden.
                      </li>
                      <li>
                        <strong>Carsharing:</strong> Wenn du dein Auto wenig
                        nutzt, kannst du es über Carsharing-Plattformen teilen
                        oder ganz auf ein eigenes Fahrzeug verzichten.
                      </li>
                    </ul>
                  </>
                }
              />
            </div>

            <div style={{ paddingTop: "120px" }}>
              <Ratgeber
                title="Mehr zum Thema Abrackprämie"
                kaputtesAuto
                unfallAuto
                autoExport
                autoBewerten
                autoVerkaufen
                listenpreisBerechnen
              />
            </div>

            <div className="Banner-sections-marken">
              <BildTextInfo
                image={höchstenPreis}
                h2
                fontSize="36px"
                title="Fazit zum Thema Abwrackprämie"
                alt="Frau sitzt in einem Auto und nutzt ihr Smartphone, um mit Autoeinfachlos ihr Auto zu verkaufen."
                text={
                  <>
                    <p>
                      Die Abwrackprämie ist ein interessantes Angebot für alle,
                      die einen Neuwagen kaufen möchten und ein altes,
                      emissionsstarkes Auto besitzen. Eine allgemeine staatliche
                      Prämie gibt es derzeit nicht, aber Hersteller locken mit
                      eigenen Aktionen. Prüfe, ob die Prämie den Wertverlust des
                      Neuwagens ausreichend kompensiert oder ob der Verkauf des
                      alten Autos lohnender ist. Autoeinfachlos unterstützt dich
                      dabei, den bestmöglichen Preis für dein Fahrzeug zu erhalten
                      und ermöglicht dir so eine umwelt- und geldbeutelschonende
                      Entscheidung.
                    </p>
                  </>
                }
              />
            </div>
          </div>
          <Banner
            link="/auto-verkaufen"
            title="Jetzt Auto kostenlos bewerten & sicher verkaufen"
          />
        </div>
      )}
    </div>
  );
}

export default AbwrackpraemieVerschrottung;
